import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui';
import { useDocumentTitle } from '@/hooks';

export function NotFoundPage() {
  useDocumentTitle('Page not found');

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 px-6 text-center">
      <span className="flex size-14 items-center justify-center rounded-full bg-surface-raised text-ink-subtle">
        <Compass className="size-6" aria-hidden />
      </span>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-[-0.02em] text-ink">This page does not exist</h1>
        <p className="max-w-sm text-pretty text-[13.5px] leading-relaxed text-ink-muted">
          The link may be out of date, or the page may have moved.
        </p>
      </div>
      <Button asChild>
        <Link to="/">Back to the dashboard</Link>
      </Button>
    </div>
  );
}
